// extracted by mini-css-extract-plugin
export default {"content":"gdocs_content__ueWOg"};